<template>
  <div id="app">

    <navigation v-if="showNavigation"></navigation>

    <div class="container-fluid">
      <router-view/>
    </div>

    <Toasts
      :max-messages="7"
      :time-out="5000"
      :closeable="true"
    ></Toasts>

  </div>
</template>

<script>
import Navigation from './components/partials/Navigation'

export default {
  name: 'App',
  components: {
    Navigation
  },
  computed: {
    showNavigation () {
      return this.$store.getters.isAuthenticated && this.$store.state.user && this.$store.getters.hasApiKey && this.$store.state.store
    }
  },
  methods: {
    /* processLogout () {
        this.$store.dispatch('processLogout')
        this.$toast.success('You have successfully logged out!')
        this.$router.push('login')
    } */
  }
}
</script>

<style>
  label.required:after {
    color: red;
    content: '*';
  }

  #app {
  }

  .pane {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .text-line-through {
    text-decoration: line-through;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue